<template>
  <search-body />
</template>

<script>
import AgeTechServiceWrite from "@/components/ageTechService/AgeTechServiceWrite.vue";

export default {
  name: "AgeTechService",
  components: {
    "search-body": AgeTechServiceWrite,
  },
};
</script>
